import styled from '@emotion/styled';

import { spacing } from '@/design-system/spacing';

export const SendPageFlow = styled('section')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minWidth: 0,
  gap: theme.spacing[24],
}));

export const SendActivityBoundary = styled('div')({ display: 'contents' });

export const SendPageVerificationFlow = styled(SendPageFlow)({
  flexGrow: 1,
  minHeight: 0,
});

export const SendPageStatusFlow = styled('section')({
  display: 'grid',
  gridTemplateRows: 'minmax(0, 1fr) auto',
  flexGrow: 1,
  width: '100%',
  minWidth: 0,
  gap: spacing[24],
  minHeight: 0,
});

export const SendPageStatusViewport = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 0,
});

export const SendPageActions = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: theme.spacing[8],

  '& > button': {
    position: 'relative',
    flex: 1,
    minHeight: spacing[48],

    '&::before': {
      content: '""',
      position: 'absolute',
      inset: -2,
    },
  },
}));
